<script setup>
defineProps({
  modelValue: { type: [String, Number], default: '' },
  label: String,
  placeholder: String,
  type: { type: String, default: 'text' },
  required: Boolean,
  error: String,
  mono: Boolean
})
defineEmits(['update:modelValue'])
</script>

<template>
  <label class="field">
    <span v-if="label" class="field__label">{{ label }}</span>
    <input
      class="field__input"
      :class="{ 'field__input--mono': mono, 'field__input--error': error }"
      :type="type"
      :value="modelValue"
      :placeholder="placeholder"
      :required="required"
      @input="$emit('update:modelValue', $event.target.value)"
    >
    <span v-if="error" class="field__error">{{ error }}</span>
  </label>
</template>

<style scoped>
.field { display: flex; flex-direction: column; gap: var(--sp-2); }
.field__label {
  font-family: var(--font-display);
  font-size: var(--fs-12);
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: var(--ink-soft);
}
.field__input {
  padding: 14px 16px;
  border-radius: var(--r-xs);
  border: 1px solid var(--ash-strong);
  background: var(--bg-glass-strong);
  color: var(--ink);
  font-size: var(--fs-16);
  transition: border-color var(--t-fast) var(--ease-road),
              background var(--t-fast) var(--ease-road),
              box-shadow var(--t-fast) var(--ease-road);
}
.field__input::placeholder { color: var(--ink-mute); }
.field__input:focus {
  outline: none;
  border-color: var(--gold);
  background: var(--bg-deep);
  box-shadow: inset 0 -2px 0 var(--gold);
}
.field__input--mono { font-family: var(--font-mono); letter-spacing: 0.04em; }
.field__input--error { border-color: var(--ember); }
.field__error {
  font-size: var(--fs-12);
  color: var(--ember);
  font-family: var(--font-display);
  text-transform: uppercase;
  letter-spacing: 0.08em;
}
</style>
